module.exports = __webpack_public_path__ + "static/media/telegram_icon.aacf86c2.svg";